import React  from 'react';
//import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
//import NormalImg from '../common/Img';
//import LogoImg from '../participants/bicamsinlogo.jpg';
import Button from '../common/Button';
import DrawingCanvas from './DrawingCanvas';
import '../../assets/css/bvmtr.css';

/*const Img = styled(NormalImg)`
  width: 200px;
  margin: 20px;
  display: block;
`;*/
const ButtonA = styled(Button)`
  background: #324971;
  color: #fff;
`;
/*const ButtonB = styled(Button)`
  background: #7A062D;
  color: #fff;
`;*/

class BVMTRTestPage extends React.Component {

render() {
        //console.log();
        return (
            <div className="normalPage">
               <div className="container"> 

                   
                    

                    <Link to="/sdmt_test"><ButtonA className="btn btn-lg btn-part-nav">Back</ButtonA></Link>

                    <DrawingCanvas />

               </div> 
            </div>
        );
    }

}

export default BVMTRTestPage;


// WEBPACK FOOTER //
// ./src/components/exam/BVMTRTestPage.js